import { BaseApolloResponse } from '@customer-portal/shared/models';

export interface UpdateLoginTimeResponse {
  updateLoginTime: BaseApolloResponse<number>;
}
